import { Table } from '@tanstack/react-table';
import { toast } from 'sonner';
import { useData } from '../../contexts/data-context/use-data';
import { useUser } from '../../contexts/user-context/use-user';
import { Button } from '../button/button';
import { BaseTableRow } from './data-table';

type DeleteSelectedRowsButtonProps<TData> = {
  table: Table<TData>;
};

export const DeleteSelectedRowsButton = <TData extends BaseTableRow>({
  table,
}: DeleteSelectedRowsButtonProps<TData>) => {
  const { authenticatedFetch } = useUser();
  const { mutations } = useData();

  return (
    <Button
      variant="destructive"
      onClick={async () => {
        const selectedVendors = table.getSelectedRowModel().rows.map((row) => row.original.id);

        try {
          await authenticatedFetch(`/api/entities/by-type/vendor`, {
            method: 'DELETE',
            body: JSON.stringify(selectedVendors),
          });

          // TODO: add some success indicator (toast?)

          await mutations.mutateAll();
        } catch {
          // TODO: add some failure indicator (toast?)

          toast.error('There was a problem deleting the vendor');
        }
      }}
    >
      Delete selected rows
    </Button>
  );
};
